import React from 'react';

const CardWrapper = ({ children }) => (
  <div className="bg-[#121212] border border-[#2a2a2a]/40 text-white rounded-xl shadow-md p-6">
    {children}
  </div>
);

export default CardWrapper;



